<template>
  <div>
    <v-btn 
      :size="buttonSize"
      color="secondary"
      class="secondary--btn"
      elevation="0"
      v-bind="$attrs"
      @click="_click"
      :disabled="disabled"
      :loading="$attrs.inAction">
        {{ label }}
        <slot name="actions"></slot>
    </v-btn>
  </div>
</template>

<script>

  export default {
    name: 'BaseButton',
    inheritAttrs: false,
    props: {
      label: { type: String },
      disabled: { type: Boolean, default: false },
      buttonSize: { type: String, default: 'large' }
    },
    emits: ["click"],
    data() {
      return { };
    },
    methods: { 
      _click() {
        this.$emit("click");
      }
    },
  };
  
</script>

<style lang="scss" scoped>

</style>